module.exports = __webpack_public_path__ + "static/media/SFProText-BoldItalic.37ad4cdd.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-BoldItalic.ttf
// module id = 2555
// module chunks = 7